import React, { Component } from "react";
import { burying } from "../../utils/buryPoint";
import { getQueryString } from "../../utils/utils";
import styles from "./index.less";

interface Props {
  type: string;
  promptList: any;
}
interface State {}
class Tips extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  linkToPrompt = () => {
    const punishId = getQueryString("punishId");
    const {
      promptList: { url ,text},
      type,
      promptList
    } = this.props;
    type === "special"?burying(
      "2",
      "notice-appeal-submit",
      `button=${text.slice(promptList.start - 1, promptList.end)}$punishid=${punishId}`,
      "ss-03",
      "undefined"
    ):burying(
      "2",
      "remark-appeal-submit",
      `button=${text.slice(promptList.start - 1, promptList.end)}$punishid=${punishId}`,
      "ss-03",
      "undefined"
    );
    window.open(url);
  };

  render() {
    const { type, promptList } = this.props;
    return (
      <div
        className={type === "special" ? styles.specialTip : styles.ordinaryTip}
      >
        <div>
          {promptList.url ? (
            <div>
              {promptList.text.slice(0, promptList.start - 1)}
              <i onClick={this.linkToPrompt}>
                {promptList.text.slice(promptList.start - 1, promptList.end)}
              </i>
              {promptList.text.slice(promptList.end)}
            </div>
          ) : (
            <div>{promptList.text}</div>
          )}
        </div>
      </div>
    );
  }
}

export default Tips;
